import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import { Box, Button } from "@mui/material";
import { PhotoEventWithPricelistAndPhotos } from 'common-models';
import { FC, MutableRefObject, useRef } from "react";
import ImageGallery, { ReactImageGalleryItem } from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { Configuration } from '../../Configuration';
import { EventGalleryPhotoToolsFree } from "./EventGalleryPhotoToolsFree";
import { EventGalleryPhotoToolsShop } from "./EventGalleryPhotoToolsShop";

type ImagesGalleryViewProps = {
    event: PhotoEventWithPricelistAndPhotos;
    startIndex: number;
    downloadImage: () => Promise<void>;
    onAddToShoppingCart?: () => void;
    onCloseGalleryView: () => void;
    onImageChanged: (index: number) => void;
}

const ImagesGalleryView: FC<ImagesGalleryViewProps> = ({ event, startIndex, downloadImage, onAddToShoppingCart, onCloseGalleryView, onImageChanged }) => {
    const imageGalleryRef = useRef(null);

    function getImagesForGallery(): Array<ReactImageGalleryItem> {
        return event.photos.map((x) => {
            // const sortedSizes = x.webSizes.sort((a,b) => a.width-b.width);
            return {
                original: `${Configuration.StaticSiteUrl}/events/${x.eventId}/${x.id}-${x.webSizes[0].width}.jpg`,
                thumbnail: `${Configuration.StaticSiteUrl}/events/${x.eventId}/${x.id}-${x.webSizes[x.webSizes.length - 1].width
                    }.jpg`,
                srcSet: x.webSizes
                    .map(
                        (y) =>
                            `${Configuration.StaticSiteUrl}/events/${x.eventId}/${x.id}-${y.width}.jpg ${y.width}w`
                    )
                    .join(", "),
            };
        });
    }

    const getCurrentPhoto = () => {
        const imageGallery: ImageGallery = (imageGalleryRef as MutableRefObject<any>).current;

        const currentImageIndex = imageGallery ? imageGallery.getCurrentIndex() : 0;
        const currentImage = event.photos[currentImageIndex];
        return currentImage;
    }

    const renderImageGalleryOverylayTools = () => {
        const currentPhoto = getCurrentPhoto();
        if (currentPhoto === undefined) {
            return <></>
        }

        return (
            <Box
                className="image-gallery-toolbox-container"
                sx={{
                    backgroundColor: 'transparent',
                    position: 'absolute',
                    left: '100%',
                    top: '100%',
                    transform: 'translate(-99%, -99%)',
                    zIndex: 100,
                    borderTopLeftRadius: 1,
                }}
            >
                {event.event.isFreeOfCharge
                    ? <EventGalleryPhotoToolsFree
                        eventId={currentPhoto.eventId}
                        photoId={currentPhoto.id}
                        downloadImage={downloadImage} />
                    : <EventGalleryPhotoToolsShop
                        onAddToShoppingCart={onAddToShoppingCart ? onAddToShoppingCart : () => { }} />
                }
            </Box>
        );
    };

    return (
        <>
            <Button
                onClick={onCloseGalleryView}
                variant="contained"
            >
                <KeyboardDoubleArrowLeftIcon /> Tillbaka
            </Button>
            <ImageGallery
                additionalClass='image-gallery-frame'

                ref={imageGalleryRef}
                items={getImagesForGallery()}
                startIndex={startIndex}
                showIndex={true}
                showThumbnails={true}
                thumbnailPosition="top"
                showPlayButton={false}
                showFullscreenButton={false}
                onSlide={(currentIndex) => onImageChanged(currentIndex)}
                renderCustomControls={renderImageGalleryOverylayTools}
            />
        </>
    );
    // }
};

export default ImagesGalleryView;
